module.exports = __webpack_public_path__ + "static/img/70-2.8f46dd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/70-2.jpg
// module id = srtb
// module chunks = 0